import Button from "../Button"
import "./Toast.scss"
import React, { useEffect, useState } from "react"

const Toast = ({
  indexZ,
  textMessage,
  onClose,
  onCloseText,
  onClickText,
  onClick,
  type,
  textarea,
  textareaContent,
  disableClickButton = false
}: any) => {

  const [textArea, setTextArea] = useState("")
  const [toastOverflow, setToastOverflow] = useState<any>(false);

  useEffect(() => {
    if (textMessage) {
      if (textMessage.includes('Interaction found between')) {
        setToastOverflow(true);
      }
    }
  }, [textMessage])

  const index = textareaContent

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9998,
        }}
      >
      </div>
      <div id="toastId"
        className="toast-wrapper"
        style={{
          zIndex: indexZ && 10006
        }}
      >
        <div
          className={`toast-card ${type}`}
          style={toastOverflow ? {
            width: '500px',
            height: '215px',
            overflow: 'scroll',
            overflowX: 'hidden',
            marginBottom: '20px',
            scrollbarWidth: 'thin',  // For Firefox
            scrollbarColor: 'darkgray lightgray',  // For Firefox
            borderRadius: '7px'
          } : {}}
        >
          <div className="patient-card-heading">
            {textMessage}
            <div className="flex textarea m-2">
              {textarea && (
                <>
                  <textarea className="textfiled" placeholder="Reason"
                    value={textArea}
                    onChange={(e) => setTextArea(e.target.value)}

                  />
                </>
              )}
            </div>
            <div className="button-section">
              {onCloseText && (
                <div className="close-button" style={{ marginBottom: "5px" }}>
                  <Button text={onCloseText} outline={true} onClick={onClose} id="onclose-button" />
                </div>
              )}
              {onClickText && (
                <div className="redirect-button">
                  <Button text={onClickText} disabled={disableClickButton
                  } onClick={() => onClick(index, textArea)} id="onclick-text" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>

  )
}
export default Toast
